import { render, staticRenderFns } from "./CarrierList.vue?vue&type=template&id=0d125e39&scoped=true&"
import script from "./CarrierList.vue?vue&type=script&lang=js&"
export * from "./CarrierList.vue?vue&type=script&lang=js&"
import style0 from "./CarrierList.vue?vue&type=style&index=0&id=0d125e39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d125e39",
  null
  
)

export default component.exports